/**
 * Static user registry for M5.
 *
 * NOTE: These are obviously fake placeholder entries. Real display names come
 * from a runtime config in a future milestone. Do not put real personal
 * information here — this file is committed to the repository.
 *
 * The `artifactPath` is relative to the viewer's public directory and
 * determines which encrypted artifact file is fetched on unlock.
 */

export interface UserEntry {
  userId: string;
  displayName: string;
  /** Path to the artifact file, relative to the viewer's public root. */
  artifactPath: string;
}

export const USERS: readonly UserEntry[] = [
  {
    userId: 'FAKE-USER-001',
    displayName: 'Neil',
    artifactPath: '/artifacts/FAKE-USER-001.artifact',
  },
  {
    userId: 'FAKE-USER-002',
    displayName: 'Family member',
    artifactPath: '/artifacts/FAKE-USER-002.artifact',
  },
];
